import { useFrame, useThree } from '@react-three/fiber';
import { useLayoutEffect } from 'react';
import { IMode, useDataStore } from '../zustand';
import { PresetAnimationController } from '@r3f/animationControllers/presetAnimationController';
import { Jute } from '..';

export let presetAnimationController: PresetAnimationController;

const PresetAnimationControllerComponent = () => {
	const { scene: threeScene,  } = useThree();
	const componentsById = useDataStore(({ componentsById }) => componentsById);
	const rootId = useDataStore(({ rootId }) => rootId);

	useLayoutEffect(() => {
		// Add global animation preset manager once threejs scene created and component data available
		// This animation preset manager is used throughout Jute to control animation presets by scene and entity ids

		if (!threeScene || !componentsById || !rootId) return;

		// The controller is a module singleton, and it holds `componentsById` as the TRANSFORM BASELINE
		// that `reset()` restores entities to (`_getInitialJuteEntityTransforms` and
		// `_resetAnimatedObjectsToInitialThreeValues` both read it). It used to be captured once at
		// construction and never refreshed — the `!!presetAnimationController` bail below returned before
		// anything was updated. That was invisible while nothing could move, but now that entity
		// transforms are reactive (PROJECT_JUTE_PREVIEW.md, Phase 1) an edited entity would move to its
		// new position and then SNAP BACK to its pre-edit one on the next reset, and orbit pivots would be
		// computed from stale coordinates.
		//
		// `set()` only swaps the stored references; it does not reset or restart animations, so it is safe
		// to call on every content update. Animation *options* are refreshed separately on scene enter.
		if (presetAnimationController) {
			presetAnimationController.set({ componentsById });
			return;
		}

		presetAnimationController = new PresetAnimationController({
			componentsById, 
			scene: threeScene,
			//debug: true,
			adjustSpatialPositions: true,
			threeEntitySelectorPrefix: 'transformGroup-',
			mode: Jute.usesOrbitCamera ? IMode.nonar : IMode.ar, 
			rootId	
		});
		
	}, [threeScene, componentsById, rootId])

	useFrame(() => {
		//console.log('frame')
		presetAnimationController?.tick()
	})

	return null;
};

export default PresetAnimationControllerComponent;
